module.exports = __webpack_public_path__ + "images/emoji/snowboarder.383705b3e2dc80e116f3.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/snowboarder.png
// module id = cvhb
// module chunks = 2